export { StructureInfoBox } from './StructureInfoBox';
